import { render, staticRenderFns } from "./RecordsPerPage.vue?vue&type=template&id=ac8560ac&"
import script from "./RecordsPerPage.vue?vue&type=script&lang=js&"
export * from "./RecordsPerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports